import { createStyles } from "@mantine/emotion";

export default createStyles ( theme => ( {
	divider: {
		borderBottom : `1px solid ${ theme.other.colors.border.primary }`,
		padding      : "1rem 0 3rem 0"
	},
	skeletonContainer: {
		padding        : "2rem",
		display        : "flex",
		alignItems     : "center",
		justifyContent : "center"
	},
	liveStreamContainer: {
		display       : "flex",
		flexDirection : "column",
		margin        : "2rem 0 0 2rem"
	},
	liveStreamCard: {
		padding       : "2rem 0",
		display       : "flex",
		flexDirection : "row"
	},
	liveStreamSide: {
		display       : "flex",
		flexDirection : "column",
		marginLeft    : "2rem"
	},
	liveStreamDivider: {
		padding: "1rem 0 1rem 0"

	}
} ) );
